import React, { useMemo } from 'react';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import Page from 'components/Page';
import CategoryArticlesList from 'components/pages/Category/components/CategoryArticlesList';
import ImagePromo from 'components/promos/ImagePromo';
import VendorsSlider from 'components/widgets/VendorsSlider';
import PopularDiscussions from 'components/widgets/PopularDiscussions';
import ArticlesWidget from 'components/widgets/Articles';

const CONTENT_COMPONENTS = {
  trending: ArticlesWidget,
  vendors: VendorsSlider,
  discussions: PopularDiscussions,
};

// Styles
import styles from './styles.styl';

const cx = cn.bind(styles);

function AuthorContentDesktop({
  articles,
  sidebar,
  promos,
  isLoading,
  page,
  paginationHref,
  changePage,
}) {
  const sectionContent = useMemo(() => {
    return {
      main: articles.items.length <= 1 ? sidebar : [],
      sidebar: articles.items.length <= 1 ? [] : sidebar,
    };
  }, [articles.items, sidebar]);

  return (
    <div className={cx('AuthorContentDesktop')}>
      <Page.Section className={cx('AuthorContentDesktop__section')}>
        <div className={cx('AuthorContentDesktop__content')}>
          {Boolean(articles.items.length) && (
            <div className={cx('AuthorContentDesktop__articles')}>
              <CategoryArticlesList
                items={articles.items}
                isLoading={isLoading}
                page={page}
                paginationHref={paginationHref}
                changePage={changePage}
                pagesLength={articles.total}
              />
            </div>
          )}
          {Boolean(sectionContent.main.length) && (
            <div
              className={cx(
                'AuthorContentDesktop__widgets',
                'AuthorContentDesktop__widgets_inContent',
              )}
            >
              {sidebar.map((widget, index) => {
                const Widget = CONTENT_COMPONENTS[widget.type];

                return Widget ? (
                  <Widget
                    className={cx('AuthorContentDesktop__widget')}
                    key={index}
                    {...widget.content}
                  />
                ) : null;
              })}
            </div>
          )}
        </div>
        <div className={cx('AuthorContentDesktop__sidebar')}>
          <ImagePromo
            gtmId={'Image_bner_Mid1'}
            className={cx('AuthorContentDesktop__promoItem')}
            id={promos[0]}
            theme="article"
          />
          <ImagePromo
            gtmId={'Image_bner_Mid2'}
            className={cx('AuthorContentDesktop__promoItem')}
            id={promos[1]}
            theme="article"
          />
          {Boolean(sectionContent.sidebar.length) && (
            <div className={cx('AuthorContentDesktop__widgets')}>
              {sidebar.map((widget, index) => {
                const Widget = CONTENT_COMPONENTS[widget.type];

                return Widget ? (
                  <Widget
                    className={cx('AuthorContentDesktop__widget')}
                    key={index}
                    {...widget.content}
                    theme="inSidebar"
                  />
                ) : null;
              })}
            </div>
          )}
        </div>
      </Page.Section>
    </div>
  );
}

AuthorContentDesktop.propTypes = {
  articles: PropTypes.shape({
    page: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  sidebar: PropTypes.arrayOf(PropTypes.object),
  promos: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  paginationHref: PropTypes.func,
  changePage: PropTypes.func,
};

AuthorContentDesktop.defaultProps = {
  sidebar: [],
  promos: [],
};

export default AuthorContentDesktop;
